
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Atom.FieldContainer';